import React from 'react';
import { Inline, InlineProps } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { useIsMobile } from '../../../hooks';
import './BottomNavBar.module.scss';

type BottomNavBarProps = InlineProps & {
  children: React.ReactNode;
  style?: object;
};

/** Height of the nav bar */
export const NAV_BAR_HEIGHT = 50;

/** Navigation bar fixed to the bottom of the screen. Hidden on mobile. */
export const BottomNavBar: React.FCWithChildren<BottomNavBarProps> = ({
  children,
  ...restProps
}) => {
  const isMobile: boolean = useIsMobile();
  if (!isMobile) {
    return null;
  }

  return (
    <Inline
      styleName="bottomNavBar"
      alignItems="center"
      justifyContent="space-around"
      color={BrandColor.WhiteWash}
      borderStyle="solid"
      borderTopWidth={1}
      borderTopColor={BrandColor.Silver}
      flex={1}
      {...restProps}
    >
      {children}
    </Inline>
  );
};

export default BottomNavBar;
